import request from "graphql-request";
import BASEURL from "../../pages/Utils/Baseurl";
import { createbrand, DeleteBrandMutation } from "../graphQL/graphMutation";
import { updatebrand } from "../graphQL/graphQuery";
import axios from "axios";
import URL from "../../pages/Utils/url";
import ConfirmationDialog from "../../components/Dialog/ConfirmationDialog";

//Create Function
export const addBrandRestService = async (formData) => {
  let status = false;
  let pending = true;
  let errormessage;
  <ConfirmationDialog open={true} pending={pending} />;
  try {
    const response = await axios.post(`${URL}brand/newBrandAdd/`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    status = true;
  } catch (err) {
    if (err.response) {
      console.error("Backend error message:", err.response.data);
      console.error("Backend error status:", err.response.status);
  errormessage= err.response.data.brand_name[0];
  console.error(errormessage,"message");
  
    } else if (err.request) {
      console.error("No response received:", err.request);
    } else {
      console.error("Error during request setup:", err.message);
    }
  } finally {
    pending = false;
    <ConfirmationDialog open={true} pending={false} />;
  }
  return { status, pending, errormessage };
};

export const updateBrandService = async (values, id) => {
  let updateStatus = false;
  let pending = true;
  let errormessage;
  try {
    const res = await request(BASEURL, updatebrand, {
      input: {
        id: id,
        ...values,
      },
    });
    updateStatus = true;
  } catch (err) {
    console.error(err.message, "updateBrandService error");
    errormessage = err.response?.data.error;
    updateStatus = false;
  } finally {
    pending = false;
  }

  return { updateStatus, errormessage, pending };
};

//Update Function
export const updateRestBrandService = async (formdata, id) => {
  let status = false;
  let errormessage;
  try {
    const response = await axios.put(
      `${URL}brand/newBrandAdd/${id}/`,
      formdata,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    status = true;
  } catch (err) {
    console.error(err.message, "brand err");
    errormessage = err.response?.data.error;
  }
  return { status, errormessage };
};

//Delete Function
export const deleteBrandService = async (id) => {
  let delteStatus = false;
  try {
    const res = await request(BASEURL, DeleteBrandMutation, { id: id });
    delteStatus = true;
  } catch (err) {
    console.error(err.message, "deleteBrandService error");
    delteStatus = false;
  }
  return delteStatus;
};
